// Pure coverage math (no DOM). The UI reads these and paints the bars.

import { clamp } from "../lib/text";
import { state, topBranchOf } from "./state";

/** Resolved decisions under a given top-level branch, as a 0..1 fill. */
export function branchCoverage(rootOptionLabel: string): number {
  let resolved = 0;
  for (const n of state.nodes.values()) {
    if (n.depth === 0) continue;
    if (topBranchOf(n) === rootOptionLabel && n.chosenIndex != null) resolved++;
  }
  return clamp(resolved / 4, 0, 1);
}

export function globalCoverage(): number {
  const root = state.rootId ? state.nodes.get(state.rootId) : null;
  let cov = 0;
  if (root && root.options.length) {
    cov = root.options.reduce((a, o) => a + branchCoverage(o.label), 0) / root.options.length;
  }
  if (!state.grounding.length) cov *= 0.85; // ungrounded → discount
  return cov;
}
